import * as React from "react";
import { useIntl } from "@grandvisionhq/state";
import { MultibancoSummary } from "./MultibancoSummary.js";
const isMultibancoResult = (result) => {
  if (!result || typeof result !== "object") {
    return false;
  }
  return "paymentExternalReference" in result && typeof result.paymentExternalReference === "string" && "paymentExternalId" in result && typeof result.paymentExternalId === "string";
};
const Multibanco = ({ result }) => {
  const { getLabel } = useIntl();
  const labels = React.useMemo(
    () => ({
      multibancoEntity: getLabel("checkout.completed.paymentDetails.multibanco.entity"),
      multibancoReference: getLabel("checkout.completed.paymentDetails.multibanco.reference"),
      multibancoMessage: getLabel("checkout.completed.paymentDetails.multibanco.hint.message"),
      multibancoTitle: getLabel("checkout.completed.paymentDetails.multibanco.hint.title")
    }),
    [getLabel]
  );
  return isMultibancoResult(result) ? /* @__PURE__ */ React.createElement(
    MultibancoSummary,
    {
      labels,
      paymentExternalId: result.paymentExternalId,
      paymentExternalReference: result.paymentExternalReference
    }
  ) : null;
};
export {
  Multibanco
};
//# sourceMappingURL=MultibancoContainer.js.map
